import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  // const [token, setToken] = useState(true);
  const [usuario, setUsuario] = useState(() => {
    const storedUser = localStorage.getItem("usuario");
    return storedUser ? JSON.parse(storedUser) : null;
  });


  useEffect(() => {
    if (!token) {
      localStorage.removeItem("token");
    }
  }, [token]);

 const handleLogin = (token, userData, expiracion) => {

    console.log('Guardando token:', token, 'usuario:', userData, 'expiracion:', expiracion);
    localStorage.setItem("token", token);
    localStorage.setItem("usuario", JSON.stringify(userData));
    localStorage.setItem("expiracion", expiracion);

    setToken(token);
    setUsuario(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    setToken(null);
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ token, usuario, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);